import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormArray, AbstractControl, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormTemplateDataEntryService } from './../services/form-template-data-entry.service';
//import { ItemDataService } from './../services/item-data.service';
import { IDataEntryForm } from './../models/data-entry.model';
import { TextDictionaryService } from './../services/text-dictionary.service';
import textList from '../../assets/data/text-dictionary.json'
import { ZpDataService } from './../services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { Subscription } from 'rxjs';
import { FinancialItemIdService } from './../services/financial-item-id.service';
import { ThemeService } from '../theme/theme-service.service';
import {CurrencyConvertService} from '../services/currency-convert.service';

@Component({
  selector: 'app-view-box',
  templateUrl: './view-box.component.html',
  styleUrls: ['./view-box.component.scss']
})
export class ViewBoxComponent implements OnInit {
  public formResult: string = "no results yet";
  public myFormGroup: FormGroup = new FormGroup({});
  public myFormTemplate: IDataEntryForm;
  public showHelp = false;
  public myTextList = textList;
  public subscription: Subscription;
  public subscription2: Subscription;
  public myItem = {};
  public buttonText = "Back";
  public currencySymbol = "&#163;"
  public dataIsLoaded: boolean = false;
  public myUser: IUser;
  public showAddButton = true;
  public showDeleteButton = true;
  public showFrequencies = false;
  public itemToDeleteId;
  public itemNameforDialog;
  public showDialog = false;
  @Input() public canEdit;
  @Input() public Id;
  @Input() public templateName;
  @Input() public financialSummary;
  @Input() public jointOwnersStats:boolean = false;

  public lastUpdateByName;
  public propertyEquityGain;
  public propertyEquity;
  public propertyDebt = 0;
  public propertyIncomePerYear;
  public propertyAnnualServiceCharge;
  public propertyAnnualRepairsAndMaintenance;
  public propertyAnnualLegalAndOtherProffessionalServices
  public propertyYearlyManagingAgentCharge;
  public propertyAnnualInsurance = 0;
  public propertyPrimaryMortgageRepayments = 0;
  public propertyNonPrimaryMortgageRepayments = 0;
  public propertyUtilities = 0;
  public propertyInsurances = 0;
  public totalSharesValue = 0;
  jointOwnersList: any[];
  isCommon: boolean;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private ftService: FormTemplateDataEntryService,
    private dictService: TextDictionaryService,
    private zenplansDataService: ZpDataService,
    private fb: FormBuilder,
    private userInfo: UserInfoService,
    private financialItemIdService: FinancialItemIdService,
    public themeService: ThemeService,
              public currencyConvert: CurrencyConvertService) {
    this.subscription = this.userInfo.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
  }

  async ngOnInit() {
    this.subscription2 = this.financialItemIdService.getMessage().subscribe(Id => {
      this.Id = Id;
      this.myInit();
    });
    //this.myInit();
  }

  async myInit() {
    this.dataIsLoaded = false;
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(this.templateName);
    let clientId = this.myUser ? ((this.myUser.sharedPlanUserId) ? this.myUser.sharedPlanUserId : this.myUser.Id) : undefined;
    if (!this.Id || this.Id == "null") {
      this.Id = await this.financialItemIdService.getMessage();
    }
    this.myItem = await this.zenplansDataService.getItem(this.Id, this.myFormTemplate.sectionTitle, clientId);
    this.lastUpdateByName = await this.zenplansDataService.getUserName(this.myItem["lastUpdateBy"]);
    await this.getFields();
    //this.dataIsLoaded = true;
    if (this.myFormTemplate.sectionTitle.toLowerCase().includes("general expenses")) {
      this.showAddButton = false;
      this.showDeleteButton = false;
      this.showFrequencies = true;
    } else {
      this.showFrequencies = false;
    }
    this.dataIsLoaded = true;
  }

  getFrequency(field_id) {
    let frequencyField = this.myFormTemplate.fields.find(field => field.fieldid == field_id + "Freq");
    return frequencyField;
  }

  async getFields() {
    //this.dataIsLoaded = false;
    var objectKeys = Object.keys(this.myItem); //this.myItem is the json for this item from the data
    var objectValues = Object.values(this.myItem);
    //remove from the template any fields that are not in the data
    //make a list of missing fields
    var notFound: string[] = [];
    this.myFormTemplate.fields.forEach(kk => {
      var myValue = "";
      var index = objectKeys.findIndex(ff => ff.toLowerCase() === kk.fieldid.toLowerCase());
      //if (kk.inputtype != "memoalways") {
      if (index == -1) { //this template field is not in the data
        notFound.push(kk.fieldid);
      }
      else {
        //Found, but value is empty - we do not want to show it in the view
        if (objectValues[index] == null || objectValues[index] == "") {
          notFound.push(kk.fieldid);
        }

      }
      //}
    });
    if (this.myFormTemplate.sectionTitle == 'property') {
      //find out if it is a primary residence
      let index = objectKeys.findIndex(key => key == "isPrimaryResidence");
      let isPrimaryResidence = objectValues[index];
      let primaryResidence: boolean = isPrimaryResidence == "Yes" || isPrimaryResidence == true;

      //calculate jointOwnerShare for the first owner specified -- but then how do we know whether to include it or not?
      index = objectKeys.findIndex(key=> key == "jointOwners");
      let jointOwnerShare = 1;
      if(index >= 0){
        let owners = objectValues[index];
        if(owners && owners[0] && owners[0].Percentage){
          jointOwnerShare = owners[0].Percentage /100;
        }
      }

      //get mortgage debt
      let mortgageValues = await this.zenplansDataService.getLinkedItemMortgagesValues(this.myItem, this.myUser, primaryResidence);
      this.propertyDebt = mortgageValues["propertyDebt"];
      if (!this.propertyDebt) { this.propertyDebt = 0; }
      this.propertyPrimaryMortgageRepayments = mortgageValues["propertyPrimaryMortgageRepayments"] * 12;
      this.propertyNonPrimaryMortgageRepayments = mortgageValues["propertyNonPrimaryMortgageRepayments"] * 12;
      if (!this.propertyPrimaryMortgageRepayments) { this.propertyPrimaryMortgageRepayments = 0; }
      if (!this.propertyNonPrimaryMortgageRepayments) { this.propertyNonPrimaryMortgageRepayments = 0; }
      this.propertyUtilities = await this.zenplansDataService.getLinkedItemUtilitiesValues(this.myItem, this.myUser, primaryResidence);
      if (!this.propertyUtilities) { this.propertyUtilities = 0; }
      this.propertyInsurances = await this.zenplansDataService.getLinkedItemInsurancesValues(this.myItem, this.myUser, primaryResidence)
      if (!this.propertyInsurances) { this.propertyInsurances = 0; }
      //stupid - just do this.myItem["originalPrice"] etc.
      index = objectKeys.findIndex(key => key == "originalPrice");
      let myOriginalValue = objectValues[index] as number;
      index = objectKeys.findIndex(key => key == "currentPrice");
      let myCurrentValue = objectValues[index] as number;
      this.propertyEquityGain = myCurrentValue - myOriginalValue;
      this.propertyEquity = myCurrentValue;

      //Rental income and expenses
      index = objectKeys.findIndex(key => key == "grossMonthlyRent");
      this.propertyIncomePerYear = (+objectValues[index]) * 12;
      index = objectKeys.findIndex(key => key == "annualServiceChargeOrGroundRent");
      this.propertyAnnualServiceCharge = objectValues[index] as number;
      index = objectKeys.findIndex(key => key == "repairsAndMaintenance");
      this.propertyAnnualRepairsAndMaintenance = objectValues[index] as number;
      index = objectKeys.findIndex(key => key == "legalAndOtherProffessionalServices");
      this.propertyAnnualLegalAndOtherProffessionalServices = objectValues[index] as number;
      index = objectKeys.findIndex(key => key == "monthlyManagingAgentCharge");
      this.propertyYearlyManagingAgentCharge = +objectValues[index] * 12;
      index = objectKeys.findIndex(key => key == "annualInsurance");
      this.propertyAnnualInsurance = objectValues[index] as number;
      // propertyIncomePerYear;
      // propertyAnnualServiceCharge;
      // propertyAnnualRepairsAndMaintenance;
      // propertyAnnualLegalAndOtherProffessionalServices
      // propertyYearlyManagingAgentCharge;
      // propertyAnnualInsurance = 0;

      if(!this.jointOwnersStats){
        this.propertyDebt *= jointOwnerShare;
        this.propertyPrimaryMortgageRepayments *= jointOwnerShare;
        this.propertyNonPrimaryMortgageRepayments *= jointOwnerShare;
        this.propertyUtilities *= jointOwnerShare;
        this.propertyInsurances *= jointOwnerShare;
        this.propertyEquityGain *= jointOwnerShare;
        this.propertyEquity *= jointOwnerShare;
        this.propertyIncomePerYear *= jointOwnerShare;
        this.propertyAnnualServiceCharge *= jointOwnerShare;
        this.propertyAnnualRepairsAndMaintenance *= jointOwnerShare;
        this.propertyAnnualLegalAndOtherProffessionalServices *= jointOwnerShare;
        this.propertyYearlyManagingAgentCharge *= jointOwnerShare;
        this.propertyAnnualInsurance *= jointOwnerShare;
      }
    }
    //remove the missing fields from the template. We don't want to show them in the view
    notFound.forEach(kk => {
      let indexToRemove = this.myFormTemplate.fields.findIndex(jj => jj.fieldid == kk);
      this.myFormTemplate.fields.splice(indexToRemove, 1);
    });

    //connecting the tmplate fields with the stored fields
    var previousInputType = "";
    this.myFormTemplate.fields.forEach(async templateObject => {
      //if (!kk.nonData) {
      var myValue = "";
      var mySonList;
      var index = objectKeys.findIndex(ff => ff.toLowerCase() === templateObject.fieldid.toLowerCase());
      var fieldValue = objectValues[index] as string;
      //if (fieldValue && fieldValue.length>0) {
      myValue = fieldValue;
      if (templateObject.listSource) {
        if (templateObject.inputtype == "dropdownshowmultiselect" ||
          templateObject.inputtype == "dropdownshowmultiselectid" ||
          templateObject.inputtype == "dropdownid") {
          let clientId = this.myUser ? (this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id) : undefined;
          //Get the name of the chosen Id
          templateObject.itemArray = await this.zenplansDataService.getSectionItemIdsAndNames(templateObject.listSource, clientId, templateObject.itemType);
          myValue = await templateObject.itemArray.find(choice => choice["Id"] == fieldValue)["itemName"];
        }
        else {
          if (templateObject.inputtype != "multicheckbox") {
            templateObject.items = await this.zenplansDataService.getSectionItemNames(
              templateObject.listSource,
              (this.myUser) ? this.myUser.Id : undefined, templateObject.itemType);
          }
        }

      }
      switch (templateObject.inputtype) {
        default: {
          if (Array.isArray(myValue) && templateObject.fieldid === 'newJointOwners') {
            console.log(`[${myValue}] is joint owner list.`);
            this.jointOwnersList = myValue;
            let o: any;
            for(o of this.jointOwnersList){
              if(o && o.share){
                if ((o && o.share) !== 100) {
                  this.isCommon = true
                  console.log('Shares != 100.')
                } else {
                  this.isCommon = false;
                  console.log('Shares == 100.')
                }
              }else{
                console.log('there are no shares.')
                this.isCommon = false;
              }
            }
          }
          if (typeof myValue === "boolean") {
            if (myValue) {
              myValue = "Yes";
            }
            else {
              myValue = "No";
            }
          }
          if (this.myFormTemplate.sectionTitle != 'general expenses') {
            this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue));
          }
          else {
            if (templateObject.inputtype != "memoalways") {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue));
            }
            if (templateObject.inputtype == "memoalways" && previousInputType != "memoalways") {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue));
            }
          }
          previousInputType = templateObject.inputtype;
          //so much for having a data driven system:
          if (templateObject.fieldid == "shareCount" && myValue != "0") {
            this.totalSharesValue = +objectValues[index + 1] * +myValue;
          }
          break;
        }
      }

      //this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue))

      //}
      //}
    });

    var yy = 0;
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  edit() {
    let editUrl = this.myFormTemplate.editurl;
    if (!editUrl) {
      editUrl = this.myFormTemplate.url;
      editUrl = editUrl.replace(/s$/, '') + "-edit";
    }
    this.router.navigate(['/' + editUrl + "/" + this.Id])
  }
  add() {
    let addUrl = this.myFormTemplate.addurl;
    if (!addUrl) {
      addUrl = this.myFormTemplate.url;
      addUrl = addUrl.replace(/s$/, '') + "_1";
    }
    this.router.navigate(['/' + addUrl])
  }
  async deleteByEvent(choice) {
    if (choice === 'Yes') {
      //get the record so we can save it in the change log
      let clientId = this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id;
      // var itemAboutToBeDeleted =
      //   await this.zenplansDataService.getItem(this.myItem["Id"], this.myFormTemplate.sectionTitle, clientId);
      this.zenplansDataService.deleteItem(this.myItem["Id"], this.myFormTemplate.sectionTitle, clientId);
      var Id: string;
      if (this.myUser.sharedPlanUserId) {
        //Id = this.myUser.delegate["delegateId"]
        Id = this.myUser.sharedPlanUserId
      }
      else {
        Id = this.myUser.Id;
      }
      this.zenplansDataService.addLog(this.myFormTemplate.sectionTitle, this.itemToDeleteId,
        Id, "", JSON.stringify(this.myItem), "", "delete");
      this.router.navigate(['/' + this.myFormTemplate.url]);

    }
    this.showDialog = !this.showDialog;

  }

  async callDialog() {
    let id = this.myItem["Id"];
    //let name = this.myItem["lookupText"]?this.myItem["lookupText"]:this.myItem["itemName"];
    let name = this.myItem["itemName"];
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }
  goto(url: string) {
    if (!url || url === "") {
      this.router.navigate(['/' + this.myFormTemplate.url]);
    } else {
      this.router.navigate(['/' + this.myFormTemplate.url + "/" + this.Id]);
    }
  }
  showMe(fieldName) {
    return true;
  }

  onSubmit() {
    this.goto(this.myFormTemplate.url);
  }

  OnDestroy() {
    this.subscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  adjustToDefaultCurrency(value: any) {
    return this.currencyConvert.monetaryValueInDefaultCurrency(value);
  }
}

